import config from '@angular/config';

import maybeWarnAboutDeleting from '../../helpers/maybeWarnAboutDeleting';
import trashIconSvg from '../../../assets/svg/UI/trash.svg';
import copyIconSvg from '../../../assets/svg/UI/copy.svg';
import closeIconSvg from '../../../assets/svg/UI/close.svg';

import viewTaskTemplateUrl from './viewTaskTemplate.html';

class ViewTaskTemplateCtrl {
  trashIconSvg = trashIconSvg;
  closeIconSvg = closeIconSvg;
  copyIconSvg = copyIconSvg;

  constructor(AlertService, Authentication, TaskTemplatesService, $uibModal, $state) {
    'ngInject';

    Object.assign(this, { AlertService, Authentication, TaskTemplatesService, $uibModal, $state });
  }

  $onInit() {
    this.areAttachmentsEnabled = config.SHIFT_TASK_ATTACHMENTS_ENABLED;
    this.loadTemplateDetails();
  }

  async loadTemplateDetails() {
    this.template = await this.TaskTemplatesService.loadTemplateDetails(this.templateId);
  }

  async deleteTaskTemplate() {
    await this.maybeWarnAboutDeletingTaskTemplate();
    this.dismiss();
    await this.TaskTemplatesService.remove(this.templateId);
  }

  maybeWarnAboutDeletingTaskTemplate() {
    return maybeWarnAboutDeleting(this.Authentication, this.$uibModal);
  }

  dismiss() {
    this.modal.dismiss();
  }

  editTemplate(templateId) {
    this.modal.close();
    this.$state.go('shiftTasks.templates.edit', { templateId });
  }

  copyTemplate() {
    this.modal.close();
    this.$state.go('shiftTasks.templates.add', { template: this.template });
  }

  hasSubtasks() {
    return this.template?.subtasks?.some((subtask) => subtask.title.trim());
  }

  hasAttachments() {
    return Boolean(this.areAttachmentsEnabled && this.template?.attachments?.length);
  }
}

export default {
  templateUrl: viewTaskTemplateUrl,
  controller: ViewTaskTemplateCtrl,
  controllerAs: 'ctrl',
  bindings: {
    modal: '<',
    templateId: '<',
  },
};
